module.exports = __webpack_public_path__ + "img/linkedin-brands.7d6ebe93.svg";